export default "__VITE_ASSET__CH_ilpf4__"